import React from "react";
import "./help.css";
import { useTranslation } from "react-i18next";
export default function Help() {
  const { t } = useTranslation("components");
  return (
    <div className="help-container">
      <a href="https://support.verysoul.com/" target="_blank" className="span-tag">
        {/* <span className="span-tag "> */}

          <img alt={t("help.alt")} src="/images/hed-2.png" />
          <span> {t("help.getHelp")}</span>
        {/* </span> */}
      </a>
    </div>
  );
}
